import { compose, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";

export default () => {
  return compose(
    applyMiddleware(thunkMiddleware),
    typeof window === "object" && typeof window.devToolsExtension !== "undefined"
      ? window.devToolsExtension()
      : (f) => f,
  );
};
